{
  "verified": "2026-09-13",
  "url": "https://www.bls.gov/cps/cpsaat47.htm",
  "sha256": "af6ab19bf0f3af4e0118c49d8fc64c9808f3fb8f0948397d290bd812cd02ad74",
  "rows": [
    [
      "total",
      "Total employed",
      3.2,
      1.7
    ],
    [
      "occupation",
      "Management occupations",
      2.5,
      1.4
    ],
    [
      "occupation",
      "Business and financial operations occupations",
      2.9,
      1.5
    ],
    [
      "occupation",
      "Computer and mathematical occupations",
      3,
      1.5
    ],
    [
      "occupation",
      "Architecture and engineering occupations",
      2.5,
      1.2
    ],
    [
      "occupation",
      "Life, physical, and social science occupations",
      3.2,
      1.7
    ],
    [
      "occupation",
      "Community and social service occupations",
      3.7,
      1.8
    ],
    [
      "occupation",
      "Legal occupations",
      3.3,
      1.7
    ],
    [
      "occupation",
      "Education, training, and library occupations",
      3.6,
      1.7
    ],
    [
      "occupation",
      "Arts, design, entertainment, sports, and media occupations",
      2.8,
      1.1
    ],
    [
      "occupation",
      "Healthcare practitioners and technical occupations",
      3.7,
      2.1
    ],
    [
      "occupation",
      "Healthcare support occupations",
      4.1,
      2.2
    ],
    [
      "occupation",
      "Sales and related occupations",
      2.8,
      1.4
    ],
    [
      "occupation",
      "Office and administrative support occupations",
      3.9,
      2
    ],
    [
      "industry",
      "Information",
      3.2,
      1.6
    ],
    [
      "industry",
      "Finance and insurance",
      2.6,
      1.4
    ],
    [
      "industry",
      "Real estate and rental and leasing",
      3,
      1.6
    ],
    [
      "industry",
      "Professional and business services",
      2.9,
      1.5
    ],
    [
      "industry",
      "Professional and technical services",
      2.9,
      1.5
    ],
    [
      "industry",
      "Management, administrative, and waste services",
      2.8,
      1.3
    ],
    [
      "industry",
      "Educational services",
      2.8,
      1.3
    ],
    [
      "industry",
      "Health care and social assistance",
      3.8,
      2.1
    ],
    [
      "industry",
      "Arts, entertainment, and recreation",
      3.1,
      1.2
    ],
    [
      "industry",
      "Accommodation and food services",
      3.4,
      1.5
    ],
    [
      "industry",
      "Retail trade",
      3.4,
      1.7
    ],
    [
      "industry",
      "Wholesale trade",
      2.3,
      1.2
    ],
    [
      "industry",
      "Transportation and warehousing",
      3.1,
      1.7
    ]
  ]
}
